import { useQuery } from "@tanstack/react-query";
import {
  CHANGELOG_BASE_URL,
  ChangelogEntry,
  ChangelogIndexEntry,
  parseFrontmatter,
  resolveChangelogAssetPaths,
} from "../../config/changelog";

export const useGetChangelogIndex = () => {
  return useQuery<ChangelogIndexEntry[]>({
    queryKey: ["changelog", "index"],
    queryFn: async () => {
      const res = await fetch(`${CHANGELOG_BASE_URL}/index.json`);
      if (!res.ok) return [];
      return res.json();
    },
    staleTime: 60 * 60 * 1000, // 1 hour
  });
};

export const useGetChangelogEntry = (filename: string | undefined) => {
  return useQuery<ChangelogEntry | null>({
    queryKey: ["changelog", "entry", filename],
    queryFn: async () => {
      if (!filename) return null;
      const res = await fetch(`${CHANGELOG_BASE_URL}/${filename}`);
      if (!res.ok) return null;
      const raw = await res.text();
      const { frontmatter, body } = parseFrontmatter(raw);
      return {
        date: frontmatter.date || "",
        title: frontmatter.title || "",
        body: resolveChangelogAssetPaths(body),
      };
    },
    staleTime: 60 * 60 * 1000,
    enabled: !!filename,
  });
};
